export default "__VITE_ASSET__BHzwf8sl__"